import mainRoutes from '../pages/main/routes';

export default [
    ...mainRoutes
];
